import React, { Component } from "react";
export default function PolygonSvg(props) {
	return (
		<svg 
			xmlns="http://www.w3.org/2000/svg"
			width={props.width} 
			height={props.height} 
			viewBox="0 0 16.933333 16.933334"
		 
		>
		<title>{props.title}</title>
		<g
			fill={props.fill} stroke={props.stroke} strokeWidth={props.strokeWidth}		
		     transform="translate(0,-280.06665)">
			<path
				d="m 2.1255085,281.9277 8.3610705,2.30937 4.922962,-1.25412 v 8.72587 l -9.4559013,4.09155 z"
			/>
		</g>
</svg>
	)}





// WEBPACK FOOTER //
// ./src/assets/img/polygon.jsx